module.exports = __webpack_public_path__ + "img/georgia.ffa34b5a.svg";